export const CUSTOMER_ATTRIBUTION_QUERY_PARAM =
  "customer_attribution_token" as const;

export const CUSTOMER_ATTRIBUTION_TRANSPORT_ID_QUERY_PARAM =
  "customer_attribution_transport_id" as const;

export const CUSTOMER_ATTRIBUTION_PARENT_ORIGIN_QUERY_PARAM =
  "customer_attribution_parent_origin" as const;

export const CUSTOMER_ATTRIBUTION_MEMORY_READER =
  "__showpassCustomerAttributionToken" as const;

export const CUSTOMER_ATTRIBUTION_ESTABLISHED_REPORTER =
  "__showpassCustomerAttributionEstablished" as const;

export const CUSTOMER_ATTRIBUTION_DISCARDED_REPORTER =
  "__showpassCustomerAttributionDiscarded" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_REQUESTER =
  "__showpassRequestCustomerAttributionRefresh" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_AVAILABLE =
  "__showpassCanRefreshCustomerAttribution" as const;

export const CUSTOMER_ATTRIBUTION_READY_MESSAGE =
  "showpass.customer-attribution.ready" as const;

export const CUSTOMER_ATTRIBUTION_INITIALIZE_MESSAGE =
  "showpass.customer-attribution.initialize" as const;

export const CUSTOMER_ATTRIBUTION_ACKNOWLEDGED_MESSAGE =
  "showpass.customer-attribution.acknowledged" as const;

export const CUSTOMER_ATTRIBUTION_ESTABLISHED_MESSAGE =
  "showpass.customer-attribution.established" as const;

export const CUSTOMER_ATTRIBUTION_DISCARDED_MESSAGE =
  "showpass.customer-attribution.discarded" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_REQUEST_MESSAGE =
  "showpass.customer-attribution.refresh-request" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_RESPONSE_MESSAGE =
  "showpass.customer-attribution.refresh-response" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_UNAVAILABLE_MESSAGE =
  "showpass.customer-attribution.refresh-unavailable" as const;

export const CUSTOMER_ATTRIBUTION_REFRESH_TIMEOUT_MS = 5000;

interface CustomerAttributionReadyMessage {
  type: typeof CUSTOMER_ATTRIBUTION_READY_MESSAGE;
  transportId: string;
}

interface CustomerAttributionInitializeMessage {
  type: typeof CUSTOMER_ATTRIBUTION_INITIALIZE_MESSAGE;
  transportId: string;
  token: string;
}

interface CustomerAttributionAcknowledgedMessage {
  type: typeof CUSTOMER_ATTRIBUTION_ACKNOWLEDGED_MESSAGE;
  transportId: string;
}

interface CustomerAttributionEstablishedMessage {
  type: typeof CUSTOMER_ATTRIBUTION_ESTABLISHED_MESSAGE;
  transportId: string;
}

interface CustomerAttributionDiscardedMessage {
  type: typeof CUSTOMER_ATTRIBUTION_DISCARDED_MESSAGE;
  transportId: string;
}

interface CustomerAttributionRefreshRequestMessage {
  type: typeof CUSTOMER_ATTRIBUTION_REFRESH_REQUEST_MESSAGE;
  transportId: string;
  requestId: string;
  expiresAt: number;
}

interface CustomerAttributionRefreshResponseMessage {
  type: typeof CUSTOMER_ATTRIBUTION_REFRESH_RESPONSE_MESSAGE;
  transportId: string;
  requestId: string;
  token: string;
}

interface CustomerAttributionRefreshUnavailableMessage {
  type: typeof CUSTOMER_ATTRIBUTION_REFRESH_UNAVAILABLE_MESSAGE;
  transportId: string;
  requestId: string;
}

export type CustomerAttributionMessage =
  | CustomerAttributionReadyMessage
  | CustomerAttributionInitializeMessage
  | CustomerAttributionAcknowledgedMessage
  | CustomerAttributionEstablishedMessage
  | CustomerAttributionDiscardedMessage
  | CustomerAttributionRefreshRequestMessage
  | CustomerAttributionRefreshResponseMessage
  | CustomerAttributionRefreshUnavailableMessage;

export function isCustomerAttributionMessage(
  value: unknown
): value is CustomerAttributionMessage {
  if (!value || typeof value !== "object") return false;

  const message = value as Record<string, unknown>;
  if (
    typeof message.transportId !== "string" ||
    message.transportId.length === 0
  ) {
    return false;
  }

  switch (message.type) {
    case CUSTOMER_ATTRIBUTION_READY_MESSAGE:
    case CUSTOMER_ATTRIBUTION_ACKNOWLEDGED_MESSAGE:
    case CUSTOMER_ATTRIBUTION_ESTABLISHED_MESSAGE:
    case CUSTOMER_ATTRIBUTION_DISCARDED_MESSAGE:
      return true;
    case CUSTOMER_ATTRIBUTION_INITIALIZE_MESSAGE:
      return typeof message.token === "string" && message.token.length > 0;
    case CUSTOMER_ATTRIBUTION_REFRESH_UNAVAILABLE_MESSAGE:
      return (
        typeof message.requestId === "string" && message.requestId.length > 0
      );
    case CUSTOMER_ATTRIBUTION_REFRESH_REQUEST_MESSAGE:
      return (
        typeof message.requestId === "string" &&
        message.requestId.length > 0 &&
        typeof message.expiresAt === "number" &&
        Number.isFinite(message.expiresAt) &&
        message.expiresAt > Date.now() &&
        message.expiresAt <=
          Date.now() + CUSTOMER_ATTRIBUTION_REFRESH_TIMEOUT_MS
      );
    case CUSTOMER_ATTRIBUTION_REFRESH_RESPONSE_MESSAGE:
      return (
        typeof message.requestId === "string" &&
        message.requestId.length > 0 &&
        typeof message.token === "string" &&
        message.token.length > 0
      );
    default:
      return false;
  }
}
